import { render, staticRenderFns } from "./subproject.vue?vue&type=template&id=1d54f29f&lang=html"
import script from "./subproject.vue?vue&type=script&lang=js"
export * from "./subproject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports